// services/guias.js
import axiosInstance from './axiosInstance';

const GUIAS_API_URL = '/guias';

const guiasService = {
  async get(idempresa, startDate, endDate) {
    try {
      const response = await axiosInstance.get(`${GUIAS_API_URL}/get.php?idempresa=${idempresa}&start_date=${startDate}&end_date=${endDate}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter guias:', error);
      return [];
    }
  },

  async getById(idempresa, doc) {
    try {
      const response = await axiosInstance.get(`${GUIAS_API_URL}/getById.php?idempresa=${idempresa}&doc=${doc}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter guia por ID:', error);
      return [];
    }
  }
};

export default guiasService;
